var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "苗场信息", width: "60" },
      model: {
        value: _vm.seedFarmFormShow,
        callback: function ($$v) {
          _vm.seedFarmFormShow = $$v
        },
        expression: "seedFarmFormShow",
      },
    },
    [
      _c("div", { staticClass: "global-tool-bar" }, [
        _c("div", { staticClass: "left-bar" }),
        _c(
          "div",
          {
            staticClass: "right-bar",
            staticStyle: { "margin-bottom": "20px" },
          },
          [
            _c(
              "Button",
              { attrs: { type: "success" }, on: { click: _vm.doPrint } },
              [_vm._v("打印订购告知书")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "Form",
        {
          ref: "seedFarmForm",
          attrs: {
            model: _vm.seedFarmForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "种苗场编号", prop: "seedFarmCode" } },
                    [
                      _c("Input", {
                        attrs: {
                          disabled:
                            _vm.seedFarmForm.formEditMode !==
                            _vm.FORM_EDIT_MODE_CREATE,
                        },
                        model: {
                          value: _vm.seedFarmForm.seedFarmCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.seedFarmForm, "seedFarmCode", $$v)
                          },
                          expression: "seedFarmForm.seedFarmCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "种苗场名称", prop: "seedFarmName" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.seedFarmForm.seedFarmName,
                          callback: function ($$v) {
                            _vm.$set(_vm.seedFarmForm, "seedFarmName", $$v)
                          },
                          expression: "seedFarmForm.seedFarmName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "所属区域", prop: "seedFarmAreaUuid" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value: _vm.seedFarmForm.seedFarmAreaUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seedFarmForm,
                                "seedFarmAreaUuid",
                                $$v
                              )
                            },
                            expression: "seedFarmForm.seedFarmAreaUuid",
                          },
                        },
                        _vm._l(_vm.areaSource, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.areaUuid,
                              attrs: { value: item.areaUuid },
                            },
                            [_vm._v(_vm._s(item.areaName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "省份", prop: "seedFarmProvince" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择省",
                          },
                          on: { "on-change": _vm.onProvinceChange },
                          model: {
                            value: _vm.seedFarmForm.seedFarmProvince,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seedFarmForm,
                                "seedFarmProvince",
                                $$v
                              )
                            },
                            expression: "seedFarmForm.seedFarmProvince",
                          },
                        },
                        _vm._l(_vm.provinceOptions, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.regionUuid,
                              attrs: { value: item.regionUuid },
                            },
                            [_vm._v(_vm._s(item.regionName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "城市", prop: "seedFarmCity" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择市",
                          },
                          on: { "on-change": _vm.onCityChange },
                          model: {
                            value: _vm.seedFarmForm.seedFarmCity,
                            callback: function ($$v) {
                              _vm.$set(_vm.seedFarmForm, "seedFarmCity", $$v)
                            },
                            expression: "seedFarmForm.seedFarmCity",
                          },
                        },
                        _vm._l(_vm.cityOptions, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.regionUuid,
                              attrs: { value: item.regionUuid },
                            },
                            [_vm._v(_vm._s(item.regionName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "区/县", prop: "seedFarmDist" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择区/县",
                          },
                          model: {
                            value: _vm.seedFarmForm.seedFarmDist,
                            callback: function ($$v) {
                              _vm.$set(_vm.seedFarmForm, "seedFarmDist", $$v)
                            },
                            expression: "seedFarmForm.seedFarmDist",
                          },
                        },
                        _vm._l(_vm.distOptions, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.regionUuid,
                              attrs: { value: item.regionUuid },
                            },
                            [_vm._v(_vm._s(item.regionName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "地址" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.seedFarmForm.seedFarmAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.seedFarmForm, "seedFarmAddress", $$v)
                          },
                          expression: "seedFarmForm.seedFarmAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "联系人" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.seedFarmForm.seedFarmContact,
                          callback: function ($$v) {
                            _vm.$set(_vm.seedFarmForm, "seedFarmContact", $$v)
                          },
                          expression: "seedFarmForm.seedFarmContact",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "联系电话",
                        prop: "seedFarmContactPhone",
                      },
                    },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.seedFarmForm.seedFarmContactPhone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.seedFarmForm,
                              "seedFarmContactPhone",
                              $$v
                            )
                          },
                          expression: "seedFarmForm.seedFarmContactPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "品牌名称", prop: "brandName" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.seedFarmForm.brandName,
                          callback: function ($$v) {
                            _vm.$set(_vm.seedFarmForm, "brandName", $$v)
                          },
                          expression: "seedFarmForm.brandName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "用友部门", prop: "ysDeptCode" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          on: { "on-select": _vm.onSelectYSDept },
                          model: {
                            value: _vm.seedFarmForm.ysDeptCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.seedFarmForm, "ysDeptCode", $$v)
                            },
                            expression: "seedFarmForm.ysDeptCode",
                          },
                        },
                        _vm._l(_vm.YSDeptOptions, function (item) {
                          return _c(
                            "Option",
                            { key: item.code, attrs: { value: item.code } },
                            [
                              _vm._v(
                                _vm._s(item.code) + " - " + _vm._s(item.name)
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "默认转运站" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { clearable: "", filterable: "" },
                          model: {
                            value: _vm.seedFarmForm.defaultDtbStationsUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seedFarmForm,
                                "defaultDtbStationsUuid",
                                $$v
                              )
                            },
                            expression: "seedFarmForm.defaultDtbStationsUuid",
                          },
                        },
                        _vm._l(
                          _vm.distributionStationsOptions,
                          function (item, index) {
                            return _c(
                              "Option",
                              { key: index, attrs: { value: item.id } },
                              [
                                _vm._v(
                                  _vm._s(item.code) + " - " + _vm._s(item.name)
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: { label: "种苗定购告知书", prop: "noticeContent" },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          id: "printContent",
                          rows: 30,
                          type: "textarea",
                        },
                        model: {
                          value: _vm.seedFarmForm.noticeContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.seedFarmForm, "noticeContent", $$v)
                          },
                          expression: "seedFarmForm.noticeContent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "示范视频" } },
                    [
                      [
                        _vm.readOnly == false && _vm.demonVideos.length < 5
                          ? _c(
                              "Upload",
                              {
                                attrs: {
                                  action: "https://up-z2.qiniup.com/",
                                  data: _vm.uploadParams,
                                  format: ["mp4"],
                                  accept: ".mp4",
                                  "on-format-error": _vm.handleFormatError,
                                  "on-success": _vm.handleUploadVideoSuccess,
                                  "before-upload": _vm.beforeVideoUpload,
                                  "show-upload-list": _vm.showUploadList,
                                },
                              },
                              [
                                _c(
                                  "Button",
                                  {
                                    attrs: { icon: "ios-cloud-upload-outline" },
                                  },
                                  [_vm._v("上传视频")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "Row",
                          {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { gutter: 16 },
                          },
                          _vm._l(_vm.demonVideos, function (item, index) {
                            return _c(
                              "Col",
                              { key: index, attrs: { span: "5" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "img-card" },
                                  [
                                    _c(
                                      "video",
                                      {
                                        attrs: {
                                          width: "150",
                                          height: "150",
                                          controls: "",
                                        },
                                      },
                                      [
                                        _c("source", {
                                          attrs: {
                                            src: item.src,
                                            type: "video/mp4",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm.readOnly == false
                                      ? _c("Icon", {
                                          staticClass: "icon-delete",
                                          attrs: { type: "md-trash" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteVideo(index)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _vm.$checkAccessArray(["S", "B", "C"])
            ? _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                [_vm._v("确认")]
              )
            : _vm._e(),
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }